export const ACTIVE_TPP = 'ACTIVE_TPP'
export const ALL_TPP = 'ALL_TPP'
export const SET_SELECTED_THIRDPARTY_PARTNER = 'SET_SELECTED_THIRDPARTY_PARTNER';


// WEBPACK FOOTER //
// ./src/store/modules/thirdparty/mutation-types.js